import { resendSignUpCode, resetPassword } from "@aws-amplify/auth";
import InputElement from "Components/Element/InputElement";
import Logo from "Components/Icons/Logo";
import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { confirmResetPassword } from 'aws-amplify/auth';
import InfoIcon from "Components/Icons/InfoIcon";
import FormErrorBanner from "Components/Element/FormErrorBanner";
import { Context } from "Context/Context";
import { isUserAvailableOnCognitoApi } from "Constants";
import SigninHeader from "./SigninHeader";
import { toast, ToastContainer } from "react-toastify";
import Footer from "Components/Header/Footer";



const ForgotPassword = ({userDetails}) => 
{
    const [apiError, setApiError] = useState("");
    const {makeApiCallFunc} = useContext(Context);
    const [successMsg, setSuccessMsg] = useState("");
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [confirmationCodeScreen, setConfirmationCodeScreen] = useState(false);  
    const [confirmationCode, setConfirmationCode] = useState(""); 
    const confirmCode = async () => {
        if(confirmationCode && newPassword && email)
        {
            try {
                await confirmResetPassword({
                username: email,
                confirmationCode: confirmationCode.trim(),
                newPassword: newPassword,
                });
                toast.success("Password updated successfully !");
                navigate("/signin");
            }
            catch (error) {
                console.log("error", error);
                setApiError(error?.message);
            }
        }
    }

    const handleSubmit = async () => {
        if(email)
        {
            makeApiCallFunc(
                isUserAvailableOnCognitoApi,
                {
                    email: email
                },
                async ({data}) => {
                    if(data.name === "UserNotFoundException")
                    {
                        setApiError("User not found");

                    }
                    else
                    {
                        console.log(data)

                        try {
                            const output = await resetPassword({
                                username: email
                            });
                          
                          const { nextStep } = output;
                          console.log(output);
                          switch (nextStep.resetPasswordStep) {
                            case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
                              const codeDeliveryDetails = nextStep.codeDeliveryDetails;
                              console.log(
                                `Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`
                              );
                              toast.success("Confirmation code sent to your email address");
                              setConfirmationCodeScreen(true);
                              break;
                            case 'DONE':
                              console.log('Successfully reset password.');
                              break;
                              default:
                              console.log("nocode");
                          }
                        } catch (error) {
            
                            setApiError(error.message);
            
                        }
                    }
                },
                (data) => {
                    setApiError("User not found");
                },
                null,
                false,
                true
            )
        }
        else
        {
            setApiError("Please enter your registered email address");
        }
    }
    const resendCode = async() => {
        console.log(email)
  
        try {
          const resendCode = await resendSignUpCode({username:email});
         if(resendCode)
           {
            console.log(resendCode);
            setApiError("");
            toast.success("Code sent successfully");
          }else {
            setSuccessMsg("");
            setApiError("Error sending code");
          }
        }
         catch (error) {
          setSuccessMsg("");
          setApiError(error?.message);
        }
      }
    return  <div className="h-full w-full">
        
    <SigninHeader/>
    <div className=" h-full pb-20 w-full flex ">
        
        <div className="font-medium w-full pb-20 border-r border-1 h-full flex flex-col items-start  ">
       
    
    <div className="font-medium w-full h-full flex flex-col items-center mt-24 justify-start ">
    <div className="text-lg font-bold">Forgot Password ? </div>
    {
       confirmationCodeScreen && email ?
        <div className=" h-auto p-5 mt-5">
           

            <div className='w-full'>
                <p className="mb-4   flex items-center justify-center">Please enter the confirmation code sent to your email Id entered.</p>
                <FormErrorBanner>{apiError}</FormErrorBanner>
                <p className="text-green-600 mb-4 text-center">{successMsg}</p>
                <InputElement
                    handleChange={(e) => setConfirmationCode(e.target.value.trim())}
                    label = "Confirmation code"
                    labelStyle={" font-bold"}
                    handleFocus={() => setApiError("")}
                    name = "code"
                    placeholder= "******"
                    value = {confirmationCode}
                />
                
                <label htmlFor="password" className="block mt-2 text-sm font-bold leading-6 text-gray-900">
                    Enter your new password
                    </label>
                    <div className="relative mt-2 rounded-md shadow-sm">
                        <input
                            type={!showPassword? "password" : "text"}
                            name="password"
                            id="password"
                            className="block w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 rounded-md border-0 py-1 pl-3 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  sm:text-sm sm:leading-6"
                            placeholder="Password"
                            onFocus={() => setApiError("")}
                            onChange={(e)=> setNewPassword(e.target.value.trim())}
                            value={newPassword}
                        />
                        <div className="absolute inset-y-0 right-0 flex mr-2 items-center">
                            {!showPassword?
                            <div onClick={() => setShowPassword(!showPassword)}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="lg:w-5 w-2 h-2 lg:h-5">
                                    <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" />
                                    <path fillRule="evenodd" d="M.664 10.59a1.651 1.651 0 010-1.186A10.004 10.004 0 0110 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0110 17c-4.257 0-7.893-2.66-9.336-6.41zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                                </svg>
                            </div>
                            :
                            <div onClick={() => setShowPassword(!showPassword)}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                                    <path fillRule="evenodd" d="M3.28 2.22a.75.75 0 00-1.06 1.06l14.5 14.5a.75.75 0 101.06-1.06l-1.745-1.745a10.029 10.029 0 003.3-4.38 1.651 1.651 0 000-1.185A10.004 10.004 0 009.999 3a9.956 9.956 0 00-4.744 1.194L3.28 2.22zM7.752 6.69l1.092 1.092a2.5 2.5 0 013.374 3.373l1.091 1.092a4 4 0 00-5.557-5.557z" clipRule="evenodd" />
                                    <path d="M10.748 13.93l2.523 2.523a9.987 9.987 0 01-3.27.547c-4.258 0-7.894-2.66-9.337-6.41a1.651 1.651 0 010-1.186A10.007 10.007 0 012.839 6.02L6.07 9.252a4 4 0 004.678 4.678z" />
                                </svg>
                            </div>
                            }
                        </div>
                    </div>
                
                <div 
                    className={" cursor-pointer w-full h-10 bg-sky-500  text-white rounded mt-5 flex justify-center items-center " + (email ? " bg-sky-500" : " bg-gray-300 opacity-50 ")}
                    onClick={confirmCode}
                    >
                        Confirm code and reset password
                </div>
                <div className=" flex justify-between cursor-pointer mt-5 font-normal text-sm">
                        <Link to="/signin" className="underline underline-offset-2 decoration-sky-500" > &lt;- Back to Home </Link>
                        <div onClick={handleSubmit} className="underline underline-offset-2 font-bold decoration-sky-500">Resend code </div>
                    
                    </div>  
            </div>
        </div> 
        :
        
        <div className="w-96 h-auto p-5 mt-5">
            <FormErrorBanner>{apiError}</FormErrorBanner>
            <div className='w-full'>

                <InputElement
                    handleChange={(e) => setEmail(e.target.value)}
                    label = "Enter your registered email address"
                    labelStyle={" font-bold"}
                    handleFocus={() => setApiError("")}
                    name = "email"
                    placeholder= "example@email.com"
                    value = {email}
                />
                
            
                <div 
                    className={" cursor-pointer w-full h-10 bg-sky-500  text-white rounded mt-5 flex justify-center items-center " + (email ? " bg-sky-500" : " bg-gray-300 opacity-50 ")}
                    onClick={handleSubmit}
                    >
                        Send confirmation code
                </div>
                <div className=" flex justify-center cursor-pointer mt-5 font-normal text-sm">
                        <Link to="/signin" className="underline underline-offset-2 decoration-sky-500" > &lt;- Back to Home </Link>
                    </div>  
            </div>
        </div>
    }
    </div>
    </div>
    </div>
    {/* <Footer/> */}
    </div>
}
export default ForgotPassword;